var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-overlay',{attrs:{"value":_vm.visible}},[_c('div',{staticClass:"text-center page-loader"},[(_vm.text)?_c('p',{staticClass:"page-loader__text"},[_vm._v(_vm._s(_vm.text))]):_vm._e(),_c('v-progress-circular',{attrs:{"indeterminate":"","color":"white"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }